import { API_BASE_URL } from "../../../../services/config";

export const viewResumeUrl = (resumePath) => {
  return `${API_BASE_URL}/RecruitmentLead/ViewResume/${encodeURIComponent(resumePath)}`;
}

 